import { Activities, ParsedActivities } from './utils';

export enum ActivitiesStatusEnum {
  GET_ACTIVITIES = 'activities/get',
  GET_ACTIVITIES_ORDER = 'activities/order/get',
  PATCH_HIDE_ORDER = 'activity/order/hide',
}

export interface BaseActivities {
  err_code: number;
  success: boolean;
  filtered: string;
  page: number;
  limit: number;
  token: string;
}

export interface ActivitiesData extends BaseActivities {
  data: Activities;
}

export interface PromiseActivitiesData extends BaseActivities {
  data: ParsedActivities;
  errors?: Array<any>;
  message?: string;
}



// WEBPACK FOOTER //
// ./src/services/api/activities/types.ts